import { Tabs, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { PERMISSIONS } from '@tms/shared';

import { useAuth } from '@/auth/AuthContext';
import { TableCard } from '@/components/TableCard';

import { OrganizationsPanel } from './platform/OrganizationsPanel';
import { PlatformAdminsPanel } from './platform/PlatformAdminsPanel';
import { RolesPanel } from './users/RolesPanel';

/**
 * Управление платформой — только для суперадминистратора: организации
 * вместе с их офисами (одна иерархия), роли и люди с полным доступом.
 * Администратор офиса сюда не попадает и управляет данными только своего
 * офиса (раздел «Администрирование»).
 */
export function PlatformPage() {
  const { t } = useTranslation();
  const { can } = useAuth();

  if (!can(PERMISSIONS.PLATFORM_MANAGE)) {
    return (
      <Typography.Text type="danger">
        {t('Нет прав на управление платформой')}
      </Typography.Text>
    );
  }

  return (
    <TableCard title={t('Глобальные настройки')}>
      <Tabs
        items={[
          {
            key: 'organizations',
            label: t('Организации'),
            children: <OrganizationsPanel />,
          },
          // Роли общие для всех организаций: правка набора прав роли действует
          // у всех заказчиков сразу, поэтому она здесь, а не в «Пользователях».
          { key: 'roles', label: t('Роли и права'), children: <RolesPanel /> },
          {
            key: 'super-admins',
            label: t('Суперадминистраторы'),
            children: <PlatformAdminsPanel />,
          },
        ]}
      />
    </TableCard>
  );
}
